import OrderTransport from './OrderTransport'
import OrderCreate from './OrderCreate'
import OrderUpdate from './OrderUpdate'
import OrderList from './OrderList'

export default {
  OrderCreate,
  OrderUpdate,
  OrderTransport,
  OrderList
}



// WEBPACK FOOTER //
// ./src/components/PreOrder/index.js